/**
 * @generated SignedSource<<eee884c2febfc95e4ef9a64623cadeac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Sources_AtlassianRovoForYou$data = ReadonlyArray<{
  readonly __typename: "ConvoAiHomeThreadsFirstPartySource";
  readonly ari: string;
  readonly data: {
    readonly __typename: string;
  } | null;
  readonly url: string;
  readonly " $fragmentType": "Sources_AtlassianRovoForYou";
} | {
  readonly __typename: "ConvoAiHomeThreadsThirdPartySource";
  readonly url: string;
  readonly " $fragmentType": "Sources_AtlassianRovoForYou";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "Sources_AtlassianRovoForYou";
}>;
export type Sources_AtlassianRovoForYou$key = ReadonlyArray<{
  readonly " $data"?: Sources_AtlassianRovoForYou$data;
  readonly " $fragmentSpreads": FragmentRefs<"Sources_AtlassianRovoForYou">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "Sources_AtlassianRovoForYou",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "ari"
        },
        (v1/*: any*/),
        {
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ],
      "type": "ConvoAiHomeThreadsFirstPartySource"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/)
      ],
      "type": "ConvoAiHomeThreadsThirdPartySource"
    }
  ],
  "type": "ConvoAiHomeThreadSource",
  "abstractKey": "__isConvoAiHomeThreadSource"
};
})();

(node as any).hash = "d049167c116591e91e93e21904443183";

export default node;
